export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-brush/src/constant.js
// module id = ../../../../d3-brush/src/constant.js
// module chunks = 3